var map = {
	"./play-da-DK@2x.png": 11360,
	"./play-de@2x.png": 56127,
	"./play-en@2x.png": 68951,
	"./play-es@2x.png": 76998,
	"./play-fr@2x.png": 60528,
	"./play-it@2x.png": 24844,
	"./play-nl@2x.png": 58487,
	"./play-no@2x.png": 11235,
	"./play-sv@2x.png": 22127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1753;